import GuestIndex from "@/views/guest/GuestIndex.vue";

const guest = [
    {
        path: '/guest',
        name: 'guest',
        component: GuestIndex
    }
]

export default guest;